import { Pipe, PipeTransform } from '@angular/core';
import { HslColor } from './hsl-color';

@Pipe({
  name: 'hslColor'
})
export class HslColorPipe implements PipeTransform {
  transform(color: HslColor): string {
    return 'hsla(' + color.hue + ', ' + color.saturation + '%, ' + color.lightness + '%)';
  }
}
